import React from 'react';
import { FaWhatsapp, FaLinkedin, FaTwitter, FaEnvelope, FaPhone, FaMapMarkerAlt, FaHeart } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 text-white overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-500/10 via-purple-500/10 to-indigo-500/10" />
        <div className="absolute -top-32 -left-32 w-64 h-64 bg-gradient-to-br from-blue-400/20 to-purple-400/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-gradient-to-br from-purple-400/20 to-indigo-400/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-gradient-to-br from-cyan-400/10 to-blue-400/10 rounded-full blur-2xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 py-8 sm:py-12 lg:py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-10 lg:mb-12">
          {/* Company Info */}
          <div className="space-y-3 sm:space-y-4 lg:space-y-6 col-span-1">
            <div>
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold bg-gradient-to-r from-blue-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent mb-2 sm:mb-3 lg:mb-4">
                Tech4All
              </h3>
              <p className="text-xs sm:text-sm lg:text-base text-gray-300 leading-relaxed">
                Turning ideas into powerful digital solutions.
              </p>
            </div>
            {/* Social Links */}
            <div className="flex space-x-2 sm:space-x-3 lg:space-x-4">
              <a 
                href="https://wa.me/918056064224" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 group"
              >
                <FaWhatsapp className="text-white text-sm sm:text-base group-hover:rotate-12 transition-transform duration-300" />
              </a>
              {/* <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 group"
              >
                <FaLinkedin className="text-white text-sm sm:text-base group-hover:rotate-12 transition-transform duration-300" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 group"
              >
                <FaTwitter className="text-white text-sm sm:text-base group-hover:rotate-12 transition-transform duration-300" />
              </a> */}
            </div>
          </div>

          {/* Quick Links and Services Container - Side by side on mobile */}
          <div className="col-span-1 sm:col-span-2 md:col-span-1 lg:col-span-2 grid grid-cols-2 md:grid-cols-2 gap-4 sm:gap-6">
            {/* Quick Links */}
            <div className="space-y-3 sm:space-y-4 lg:space-y-6">
              <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-white mb-2 sm:mb-3 lg:mb-4">Quick Links</h4>
              <ul className="space-y-1 sm:space-y-2 lg:space-y-3">
                {['Home', 'Services', 'Portfolio', 'Contact'].map((link) => (
                  <li key={link}>
                    <a 
                      href={`/${link.toLowerCase()}`}
                      className="text-xs sm:text-sm lg:text-base text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 flex items-center group"
                    >
                      <span className="w-0 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 group-hover:w-4 transition-all duration-300 mr-0 group-hover:mr-2"></span>
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="space-y-3 sm:space-y-4 lg:space-y-6">
              <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-white mb-2 sm:mb-3 lg:mb-4">Services</h4>
              <ul className="space-y-1 sm:space-y-2 lg:space-y-3">
                {[
                  'Web Development',
                  'Mobile Apps',
                  'UI/UX Design',
                  'Digital Marketing',
                  'SEO Optimization'
                ].map((service) => (
                  <li key={service} className='text-xs sm:text-sm lg:text-base text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 flex items-center group'>
                    <span className="w-0 h-0.5 bg-gradient-to-r from-purple-400 to-cyan-400 group-hover:w-4 transition-all duration-300 mr-0 group-hover:mr-2"></span>
                    {service}
                    {/* <a 
                      href="/services"
                      className="text-xs sm:text-sm lg:text-base text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 flex items-center group"
                    >
                      <span className="w-0 h-0.5 bg-gradient-to-r from-purple-400 to-cyan-400 group-hover:w-4 transition-all duration-300 mr-0 group-hover:mr-2"></span>
                      {service}
                    </a> */}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-3 sm:space-y-4 lg:space-y-6 col-span-1">
            <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-white mb-2 sm:mb-3 lg:mb-4">Get In Touch</h4>
            <div className="space-y-2 sm:space-y-3 lg:space-y-4">
              <div className="flex items-start space-x-2 sm:space-x-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <FaEnvelope className="text-white text-xs" />
                </div>
                <span className="text-xs sm:text-sm lg:text-base text-gray-300">contact@tech4all.in</span>
              </div>
              <div className="flex items-start space-x-2 sm:space-x-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <FaPhone className="text-white text-xs" />
                </div>
                <span className="text-xs sm:text-sm lg:text-base text-gray-300">+91-8056064224</span>
              </div>
              {/* <div className="flex items-start space-x-2 sm:space-x-3">
                <div className="w-4 h-4 sm:w-5 sm:h-5 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <FaMapMarkerAlt className="text-white text-xs" />
                </div>
                <span className="text-xs sm:text-sm lg:text-base text-gray-300">931 Abia Martin Drive<br />PA, Pennsylvania - 18104</span>
              </div> */}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700/50 pt-4 sm:pt-6 lg:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 sm:space-y-3 md:space-y-0">
            <div className="flex items-center space-x-1 sm:space-x-2 text-xs sm:text-sm lg:text-base text-gray-300">
              <span> {currentYear} Tech4All. Made with</span>
              <FaHeart className="text-red-400 animate-pulse text-xs sm:text-sm" />
              <span>in India</span>
            </div>
            <div className="flex space-x-3 sm:space-x-4 lg:space-x-6 text-xs sm:text-sm text-gray-400">
              <a href="/privacy" className="hover:text-white transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="/terms" className="hover:text-white transition-colors duration-300">
                Terms of Service
              </a>
              <a href="/cookies" className="hover:text-white transition-colors duration-300">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Bottom Wave */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-8" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
            opacity=".25"
            className="fill-blue-500/20"
          />
          <path
            d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
            opacity=".5"
            className="fill-purple-500/20"
          />
          <path
            d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
            className="fill-indigo-500/30"
          />
        </svg>
      </div>
    </footer>
  );
};

export default Footer;
